import Icecream1 from "../img/i1.png";
import Curry1 from "../img/cu1.png";
import Fruit1 from "../img/f1.png";
import Fish2 from "../img/fi2.png";

export const prodsDisplay = [
  {
    id: 1,
    name: "Icecream",
    desc: "Choclate & Vanilla",
    price: "5.25",
    img: Icecream1,
  },
  {
    id: 2,
    name: "Strawberries",
    desc: "Fresh and Juicy",
    price: "7.65",
    img: Fruit1,
  },
  {
    id: 3,
    name: "Chicken Curry",
    desc: "Spicy & extra Butter",
    price: "12.30",
    img: Curry1,
  },
  {
    id: 4,
    name: "Fried Fish",
    desc: "Great with chatni",
    price: "17.50",
    img: Fish2,
  },
];

export const categories = [
  {
    id: 1,
    name: "Chicken",
    urlParamName: "chicken",
  },

  {
    id: 2,
    name: "Curry",
    urlParamName: "curry",
  },
  {
    id: 3,
    name: "Rice",
    urlParamName: "rice",
  },
  {
    id: 4,
    name: "Fish",
    urlParamName: "fish",
  },
  {
    id: 5,
    name: "Fruits",
    urlParamName: "fruits",
  },

  {
    id: 6,
    name: "Icecreams",
    urlParamName: "icecreams",
  },
  {
    id: 7,
    name: "soft Drinks",
    urlParamName: "drinks",
  },
];
